<template>
  <div class="redirect_view d-flex flex-column align-center justify-center">
    <div class="d-flex flex-md-row flex-column align-center">
      <div class="logo mb-6 mb-0 mr-md-12 mr-0"></div>
      <div class="logo_medi mb-6"></div>
    </div>
    <div class="text mb-6 mx-4 mx-md-0">
      {{ $t('redirect.text_step') }}
    </div>
    <div class="text mb-6 mx-4 mx-md-0">
      <span class="bold">{{ $t('redirect.text_medipoint') }}</span><br/>
      <span v-if="$route.params.mode == 'login'">
        {{ $t('redirect.text_login') }}
        <span class="bold">bank.invicta.pl</span>
      </span>.
    </div>
  </div>
</template>

<script>
  import { useStore } from 'vuex'
  import { computed } from 'vue'

  export default {
    setup() {
      const store = useStore()
      const env = process.env.VUE_APP_ENV
      const redirectTimeout = (env == 'prod') ? 3000 : 1000
      const redirectHandle = null
      const logo_img = computed({
        get: () => { return require('../assets/svg/Invicta_bank_plodnosci.svg');}
      })
      const logo_medi_img = computed({
        get: () => { return require('../assets/img/medipoint_logo.svg');}
      })
      return {
        store,
        redirectTimeout,
        redirectHandle,
        logo_img,
        logo_medi_img
      }
    },
    mounted() {
      const redirectPath = this.$route.query?._locale ?
        `${this.$route.params.pathname}?_locale=${this.$route.query._locale}`
        : 
        this.$route.params.pathname;
      const redirectUrl = this.$route.params.url;

      switch(this.$route.params.mode) {
        case 'simple':
          this.redirectHandle = setTimeout(() => {
            this.$router.replace(redirectPath).then(() => {
              if (redirectUrl) window.location.href = redirectUrl
            });
          }, this.redirectTimeout)
        break;
        case 'login': 
          this.redirectHandle = setTimeout(() => {
            this.$router.replace(redirectPath).then(() => {
              this.store.dispatch('oidcStore/authenticateOidc',
                { redirectPath: redirectPath }
              );
            });
          }, this.redirectTimeout)
        break;
      }
    },
    beforeUnmount() {
      clearTimeout(this.redirectHandle);
    }
  }
</script>

<style scopen lang="scss">
  .redirect_view {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100vw;
    height: 100vh;
    background: white;
    z-index: 10;
    .logo {
      width: 280px;
      height: 66px;
      background: url('../assets/svg/Invicta_bank_plodnosci.svg');
      background-repeat: no-repeat;
      background-size: contain;
      margin: 0;
    }
    .logo_medi {
      width: 280px;
      height: 100px;
      background: url('../assets/img/medipoint_logo.svg');
      background-repeat: no-repeat;
      background-size: contain;
      margin: 0;
    }
    .text {
      max-width: 588px;
      @include nsb-font-container;
      font-size: 16px;
      line-height: 24px;
      .bold {
        @include nsb-font-container-medium;
        font-size: 16px;
        line-height: 24px;
      }
    }
  }

  @media (min-width: 960px) {
    .redirect_view {
    .logo {
      width: 300px;
      height: 100px;
    }
    }
  }
</style>